import { Divider, Stack } from "@mui/material";

import TimelineHeader from "./timeline-header";
import TimelineSectionContent from "./timeline-section-content";

function TimelineTab() {
    return (
        <Stack
            sx={{
                p: "1.5rem",
                gap: "1.5rem",
            }}
        >
            <TimelineHeader />
            <Divider
                sx={{
                    height: "0.125rem",
                    width: "100%",
                }}
            />
            <TimelineSectionContent />
        </Stack>
    );
}

export default TimelineTab;
